import c3 from '../../views/enlace/Enlace.vue'
import DashboardEnlace from '../../views/enlace/DashboardEnlace.vue'
import Aspirantes from '../../views/enlace/Aspirantes.vue'
import PersonalEnlace from '../../views/enlace/Personal.vue'
import ArchivoAspirantes from '../../views/enlace/ArchivoAspirantes.vue'
import NuevosIngresos from '../../views/enlace/NuevosIngresos.vue'
import DocumentosPreaspiranteEnlace from '../../views/enlace/DocumentosPreaspirante.vue'
import TurnaC3 from '../../views/enlace/TurnaC3.vue'
import ExpedientePersonalPage from '../../views/common/ExpedientePersonalPage.vue'
import SancionesAdministrativas from '../../views/enlace/SancionesAdministrativas.vue'
import RegistrarSancion from '../../views/enlace/RegistrarSancion.vue'
import AdscripcionEnlace from '../../views/enlace/AdscripcionEnlace.vue'
import AgregaDocumentoEnlace from '../../views/enlace/AgregaDocumentoPersonal.vue'
import AgregaReferenciaC3 from '../../views/enlace/AgregaReferencia.vue'
import AgregaFamiliarC3 from '../../views/enlace/AgregaFamiliar.vue'
import AgregaEstudioPersonalC3 from '../../views/enlace/AgregaEstudioPersonal.vue'

function castRouteParams(route) {
  return {
    id: Number(route.params.id),
  }
}

const EnlaceC3Route = {
  path: '/enlace_c3',
  name: 'C3',
  component: c3,
  children: [
    {
      path: 'dashboard',
      component: DashboardEnlace,
      name: 'dashboardEnlace',
    },
    {
      path: 'aspirantes',
      component: Aspirantes,
      name: 'aspirantes',
    },
    {
      path: 'personal',
      component: PersonalEnlace,
      name: 'personalEnlace',
    },
    {
      path: '/enlace_c3/archivo-aspirantes',
      component: ArchivoAspirantes,
      name: 'ArchivoAspirantes',
    },
    {
      path: '/enlace_c3/nuevos-ingresos',
      component: NuevosIngresos,
      name: 'NuevosIngresos',
    },
    {
      path: 'documentos_preaspirante/:id',
      component: DocumentosPreaspiranteEnlace,
      name: 'documentosPreaspiranteEnlace',
      props: castRouteParams,
    },
    {
      path: 'turna_c3/:id',
      component: TurnaC3,
      name: 'turnaC3',
      props: castRouteParams,
    },
    {
      path: 'expediente_personal/:id',
      component: ExpedientePersonalPage,
      name: 'expedientePersonal',
      props: castRouteParams,
    },
    {
      path: 'sanciones_administrativas',
      component: SancionesAdministrativas,
      name: 'sancionesAdministrativas',
    },
    {
      path: 'registrar_sancion',
      component: RegistrarSancion,
      name: 'registrarSancion',
    },
    {
      path: 'adscripcion_enlace/:id',
      component: AdscripcionEnlace,
      name: 'adscripcionEnlace',
      props: castRouteParams,
    },
    {
      path: 'agrega_documento_enlace/:id',
      component: AgregaDocumentoEnlace,
      name: 'agregaDocumentoEnlace',
      props: castRouteParams,
    },
    {
      path: 'agrega_familiar/:id',
      component: AgregaFamiliarC3,
      name: 'enlace_c3.agrega_familiar',
      props: castRouteParams,
    },
    {
      path: 'agrega_referencia/:id',
      component: AgregaReferenciaC3,
      name: 'enlace_c3.agrega_referencia',
      props: castRouteParams,
    },
    {
      path: 'agrega_estudio_personal/:id',
      component: AgregaEstudioPersonalC3,
      name: 'agregaEstudioPersonalC3',
      props: castRouteParams,
    },
  ],
}

export default EnlaceC3Route
